import { apiUrl, currentUser, set } from '../../state';
import { toast } from '../ui';

export function initConnectionSection(): void {
  const label = document.getElementById('connModeLabel');
  if (label) label.textContent = `Live · ${apiUrl}`;
}

export function saveWorkerUrl(): void {
  const newUrl = (document.getElementById('connUrlInp') as HTMLInputElement).value.trim();
  if (!newUrl) { toast('error', 'กรุณาใส่ URL'); return; }
  set.apiUrl(newUrl);
  localStorage.setItem('hr_api_url', newUrl);
  sessionStorage.setItem('hr_api_url', newUrl);
  toast('success', 'บันทึก URL แล้ว');
  testConnection();
}

export async function testConnection(): Promise<void> {
  const btn    = document.getElementById('testConnBtn') as HTMLButtonElement;
  const banner = document.getElementById('connStatusBanner') as HTMLElement;
  const label  = document.getElementById('connModeLabel') as HTMLElement;
  const url = (document.getElementById('connUrlInp') as HTMLInputElement).value.trim() || apiUrl;
  btn.disabled = true;
  btn.innerHTML = '<i class="ti ti-loader spin"></i> กำลังทดสอบ...';
  banner.style.display = 'flex';
  banner.style.background = '#F3F4F6';
  banner.style.color = 'var(--muted)';
  banner.textContent = `กำลังเชื่อมต่อ... (${url})`;
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    const res = await fetch(`${url}?action=ping`, {
      redirect: 'follow',
      headers: { 'Authorization': `Bearer ${currentUser?.token ?? ''}` },
      signal: controller.signal,
    });
    clearTimeout(timer);
    if (res.ok || res.status === 404 || res.status === 401) {
      banner.style.background = '#DCFCE7'; banner.style.color = '#15803D';
      banner.textContent = 'เชื่อมต่อสำเร็จ — Worker ตอบสนอง';
      label.textContent = `โหมด: Live · ${url}`;
    } else {
      banner.style.background = '#FEE2E2'; banner.style.color = 'var(--red)';
      banner.textContent = `Worker มีข้อผิดพลาด: ${res.status}`;
    }
  } catch (e) {
    banner.style.background = '#FEE2E2'; banner.style.color = 'var(--red)';
    banner.textContent = `ไม่สามารถเชื่อมต่อ Worker ได้: ${(e as Error).message}`;
    label.textContent = 'โหมด: ไม่มีการเชื่อมต่อ';
  }
  btn.disabled = false;
  btn.innerHTML = '<i class="ti ti-plug-connected"></i> ทดสอบการเชื่อมต่อ';
}
